import ReactGA from 'react-ga4'
import { getCurrentPlaylistName, isPrivatePlaylistEntry } from './playlistUtils'

export const ANALYTICS_EVENTS = {
    CLOSE_CONSENT: { action: 'close_dialog', category: 'consent' },
    CLOSE_WELCOME: { action: 'close_dialog', category: 'welcome' },
    HIDE_WELCOME: { action: 'hide_dialog', category: 'welcome' },
    MUTE: { action: 'mute', category: 'mute' },
    UNMUTE: { action: 'mute', category: 'unmute' },
    START_PLAYBACK: { action: 'play', category: 'start' },
    STOP_PLAYBACK: { action: 'play', category: 'stop' },
    SWIPE_UP: { action: 'swipeup', category: 'swipe_card' },
    SWIPE_DOWN: { action: 'swipedown', category: 'swipe_card' }

}

export const initializeAnalytics = () => {
    ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID)
}

/**
 * 
 * @param {*} event An ANALYTICS_EVENTS
 * @param {*} label 
 */
export const track = (event, label) => {
    const { action, category } = event
    if (label) {
        ReactGA.event({ action, category, label })
    } else {
        ReactGA.event({ action, category })
    }
}

/**
 * Track the current playList entry if it is not private.
 * @param {*} event 
 * @param {*} value 
 */
export const trackCurrentPlaylistEntry = (event, value) => {
    if (!isPrivatePlaylistEntry()) {
        const { action, category } = event
        if (value) {
            ReactGA.event({ action, category, label: getCurrentPlaylistName(), value })
        } else {
            ReactGA.event({ action, category, label: getCurrentPlaylistName() })
        }
    }

}